<template>
  <span class="text-xl text-nowrap font-bold">
    Super<span class="text-primary font-bold">Trade</span></span
  >
</template>
